import io from "socket.io-client";

// Configuración del socket
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

// Crear la instancia del socket con mejor configuración
export const socket = io(SOCKET_URL, {
  path: "/api/alert/socket-init",
  transports: ["websocket", "polling"],
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
  withCredentials: true,
});

// Mapa para almacenar los listeners activos
const eventListeners = new Map();

// Variable para modo debug
let debugMode = true;

/**
 * Activar/desactivar modo debug
 */
export const setDebugMode = (enabled) => {
  debugMode = enabled;
};

/**
 * Suscribirse a un evento del socket
 */
export const subscribeToEvent = (eventName, callback) => {
  if (!eventListeners.has(eventName)) {
    eventListeners.set(eventName, new Set());
  }

  eventListeners.get(eventName).add(callback);
  socket.on(eventName, callback);

  if (debugMode) {
  }

  return () => {
    if (eventListeners.has(eventName)) {
      eventListeners.get(eventName).delete(callback);
      socket.off(eventName, callback);

      if (eventListeners.get(eventName).size === 0) {
        eventListeners.delete(eventName);
      }

      if (debugMode) {
      }
    }
  };
};

/**
 * Limpiar todos los listeners
 */
export const clearAllListeners = () => {
  eventListeners.forEach((callbacks, eventName) => {
    callbacks.forEach((callback) => {
      socket.off(eventName, callback);
    });
  });
  eventListeners.clear();

  if (debugMode) {
  }
};

/**
 * Emitir un evento al servidor
 */
export const emitEvent = (eventName, data) => {
  if (socket.connected) {
    socket.emit(eventName, data);
    if (debugMode) {
    }
    return true;
  }
  if (debugMode) {
    console.warn(`⚠️ Socket no conectado, no se pudo emitir: ${eventName}`);
  }
  return false;
};

/**
 * Solicitar alertas al servidor
 */
export const requestAlerts = () => {
  if (socket.connected) {
    emitEvent("request_alerts", { timestamp: new Date().toISOString() });
    return true;
  }
  return false;
};

/**
 * Enviar alerta de prueba (formato Zabbix)
 */
export const sendTestAlert = () => {
  if (!socket.connected) {
    console.warn("⚠️ Socket no conectado, no se puede enviar alerta de prueba");
    return false;
  }

  const testAlerts = [
    {
      event: "zabbix_alert",
      data: {
        id: Date.now().toString(),
        alert_type: "Zabbix",
        host: "EDS TERPEL CHIPICHAPE - Reader",
        ip: "1776112884",
        msm: "Load averages(1m 5m 15m): (4.19 3.68 2.95), # of CPUs: 1",
        priority: 3,
        metadata: {
          name: "Promedio de carga elevado (per CPU load over 1.5 for 5m)",
          eventid: Date.now().toString(),
          severity: "3",
          clock: Math.floor(Date.now() / 1000).toString(),
        },
        createdAt: new Date().toISOString(),
        status: 0,
      },
    },
    {
      event: "zabbix_alert",
      data: {
        id: Date.now().toString(),
        alert_type: "Zabbix",
        host: "EDS TERPEL PONTEVEDRA - Reader",
        ip: "1776113112",
        msm: "Current state: available (1)",
        priority: 4,
        metadata: {
          name: "No hay respuesta SNMP",
          eventid: Date.now().toString(),
          severity: "4",
          clock: Math.floor(Date.now() / 1000).toString(),
        },
        createdAt: new Date().toISOString(),
        status: 0,
      },
    },
    {
      event: "reader_alert",
      data: {
        message: "Load average is too high (per CPU load over 1.5 for 5m)",
        reader_name: "CC Chipchape - Reader - Porta 2",
        severity: "warning",
        timestamp: new Date().toISOString(),
      },
    },
    {
      event: "cpu_alert",
      data: {
        message: "High CPU utilization (over 90% for 5m)",
        equipment: "CC Chipchape - Reader - Porta 2",
        load: 2.1,
        severity: "error",
        timestamp: new Date().toISOString(),
      },
    },
    {
      event: "memory_alert",
      data: {
        message: "Poca memoria disponible (<20M of 240.65 MB)",
        service: "EDS TERPEL CORZO II - Reader",
        usage: 95,
        severity: "error",
        timestamp: new Date().toISOString(),
      },
    },
  ];

  const randomIndex = Math.floor(Math.random() * testAlerts.length);
  const test = testAlerts[randomIndex];

  emitEvent(test.event, test.data);

  if (debugMode) {
  }

  return true;
};

// Eventos de conexión para debug
socket.on("connect", () => {
  // Solicitar alertas al conectarse
  setTimeout(() => {
    requestAlerts();
  }, 1000);
});

socket.on("connect_error", (error) => {
  console.error("❌ Error de conexión del socket:", error.message);
});

socket.on("reconnect", (attemptNumber) => {
  // Solicitar alertas después de reconectar
  setTimeout(() => {
    requestAlerts();
  }, 500);
});

// Escuchar todos los eventos para debug
if (process.env.NODE_ENV === "development") {
  socket.onAny((event, ...args) => {
    if (event !== "connect" && event !== "disconnect" && event !== "connect_error") {
    }
  });
}

export default socket;
